import { render, staticRenderFns } from "./AllCollectionTask.vue?vue&type=template&id=04c00f74&scoped=true"
import script from "./AllCollectionTask.vue?vue&type=script&lang=js"
export * from "./AllCollectionTask.vue?vue&type=script&lang=js"
import style0 from "./AllCollectionTask.vue?vue&type=style&index=0&id=04c00f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c00f74",
  null
  
)

export default component.exports